// Core packages
import { TranslationService } from "../../services/translation.service";

// Third party packages
import { Component, Input, OnInit } from "@angular/core";

// Custom packages

@Component({
  selector: "app-creator-updator-box",
  templateUrl: "./creator-updator-box.component.html",
  styleUrls: ["./creator-updator-box.component.scss"]
})
export class CreatorUpdatorBoxComponent implements OnInit {
  @Input() data: any;
  @Input() showUserName?: boolean;
  lang: string;

  showUserSection = true;

  constructor(private translationService: TranslationService) {}

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    this.lang = this.translationService.getSelectedLanguage();

    if (typeof this.showUserName !== "undefined") {
      this.showUserSection = this.showUserName;
    }
  }
}
